/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_Psm_Single_LineInputs */

const en_ocr_psm_single_line = /** @type {(inputs: Ocr_Psm_Single_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Single Line`)
};

const fr_ocr_psm_single_line = /** @type {(inputs: Ocr_Psm_Single_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ligne unique`)
};

const de_ocr_psm_single_line = /** @type {(inputs: Ocr_Psm_Single_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einzellinie`)
};

const it_ocr_psm_single_line = /** @type {(inputs: Ocr_Psm_Single_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linea singola`)
};

const ru_ocr_psm_single_line = /** @type {(inputs: Ocr_Psm_Single_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Однолинейный`)
};

const es_ocr_psm_single_line = /** @type {(inputs: Ocr_Psm_Single_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Línea única`)
};

const zh_cn2_ocr_psm_single_line = /** @type {(inputs: Ocr_Psm_Single_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`单线`)
};

const ja_ocr_psm_single_line = /** @type {(inputs: Ocr_Psm_Single_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`単線`)
};

const hi_ocr_psm_single_line = /** @type {(inputs: Ocr_Psm_Single_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एक लाइन`)
};

const pt_pt2_ocr_psm_single_line = /** @type {(inputs: Ocr_Psm_Single_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linha única`)
};

/**
* | output |
* | --- |
* | "Single Line" |
*
* @param {Ocr_Psm_Single_LineInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_psm_single_line = /** @type {((inputs?: Ocr_Psm_Single_LineInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Psm_Single_LineInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ocr_psm_single_line(inputs)
	if (locale === "de") return de_ocr_psm_single_line(inputs)
	if (locale === "it") return it_ocr_psm_single_line(inputs)
	if (locale === "ru") return ru_ocr_psm_single_line(inputs)
	if (locale === "es") return es_ocr_psm_single_line(inputs)
	if (locale === "zh-CN") return zh_cn2_ocr_psm_single_line(inputs)
	if (locale === "ja") return ja_ocr_psm_single_line(inputs)
	if (locale === "hi") return hi_ocr_psm_single_line(inputs)
	if (locale === "pt-PT") return pt_pt2_ocr_psm_single_line(inputs)
	return en_ocr_psm_single_line(inputs)
});